<template>
  <div class="border-2 border-dashed border-inherit">
    <img
      class="block w-full h-auto"
      :src="src"
      :srcset="srcset"
      :style="{
        transform: rotate ? 'rotate(-5deg)' : '',
        transformOrigin: 'bottom left',
      }"
    />
    <slot name="content" />
  </div>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    src: {
      type: String,
    },
    srcset: {
      type: String,
    },
    rotate: {
      type: Boolean,
    },
  },
  setup() {
    return {};
  },
});
</script>
